import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notProperty'
})
export class NotPropertyPipe implements PipeTransform {
  transform(items: any[], property: string): any {
    if (!property) {
      return items;
    }
    return items.filter(item => !item[property]);
  }
}
